import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function getExtrasFilterOptions() {
  return getAPIResponse('/v1/extras/filter-options');
}
